import { render, staticRenderFns } from "./MyParty.vue?vue&type=template&id=19d8a7c8"
import script from "./MyParty.vue?vue&type=script&lang=js"
export * from "./MyParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports